import { render, staticRenderFns } from "./riskPointDetail.vue?vue&type=template&id=9d3fdb50&scoped=true"
import script from "./riskPointDetail.vue?vue&type=script&lang=js"
export * from "./riskPointDetail.vue?vue&type=script&lang=js"
import style0 from "./riskPointDetail.vue?vue&type=style&index=0&id=9d3fdb50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d3fdb50",
  null
  
)

export default component.exports